import {Action, createReducer, on} from '@ngrx/store';

import * as generalActions from './general.actions';
import {UserState} from '../../users/redux/users.reducers';
import {RoleState} from '../../roles/redux/roles.reducers';
import {TruckState} from '../../trucks/redux/trucks.reducer';
import {PersonState} from '../../persons/redux/persons.reducer';
import {ProductState} from '../../products/redux/products.reducer';
import {TrailerState} from '../../trailers/redux/trailers.reducer';
import {InvoiceState} from '../../invoices/redux/invoices.reducers';
import {CatalogueState} from '../../catalogs/redux/catalogs.reducer';
import {OperatorState} from '../../operators/redux/operators.reducer';
import {CustomerState} from '../../customers/redux/customers.reducer';
import {ProviderState} from '../../providers/redux/providers.reducer';
import {AuthState} from '../../authentication/redux/authentication.reducers';
import {InformationState} from '../../informations/redux/informations.reducer';
import {InformationBlockState} from '../../information-blocks/redux/information-blocks.reducer';
import {BranchOfficeState} from '../../branch-offices/redux/branch-offices.reducers';
import {ConfigurationState} from '../../configurations/redux/configurations.reducer';
import {PaymentCreditState} from '../../payment-credits/redux/payment-credits.reducers';
import {ConsignmentNotesState} from '../../consignment-notes/redux/consignment-notes.reducer';
import {LiquidationState} from '../../liquidations/redux/liquidations.reducers';
import {ComplementState} from '../../complements/redux/complements.reducers';
import {CreditNoteState} from '../../credit-notes/redux/credit-notes.reducers';
import {DebitNoteState} from '../../debit-notes/redux/debit-notes.reducers';
import {BankState} from "../../banks/redux/banks.reducer";
import {RemissionState} from "../../remissions/redux/remissions.reducers";
import { LocalTravelState } from 'app/main/local-travels/redux/local-travels.reducers';
import { ForeingTravelState } from 'app/main/foreing-travels/redux/foreing-travels.reducers';

export class AppState {
    auth: AuthState;
    general: GeneralState;
    consignmentNotes: ConsignmentNotesState;
    informations: InformationState;
    informationBlocks: InformationBlockState;
    paymentCredits: PaymentCreditState;
    liquidations: LiquidationState;
    banks: BankState;
    remissions: RemissionState;
    invoices: InvoiceState;
    debitNotes: DebitNoteState;
    complements: ComplementState;
    creditNotes: CreditNoteState;
    customers: CustomerState;
    branchOffices: BranchOfficeState;
    providers: ProviderState;
    operators: OperatorState;
    persons: PersonState;
    trailers: TrailerState;
    trucks: TruckState;
    products: ProductState;
    catalogs: CatalogueState;
    users: UserState;
    roles: RoleState;
    configurations: ConfigurationState;
    travels: LocalTravelState;
    foreingTravels: ForeingTravelState;
}

export class GeneralState {
    showLoading: boolean;

    constructor() {
        this.showLoading = true;
    }
}

const _generalReducer = createReducer(
    new GeneralState(),
    on(generalActions.hideLoading, (state, {showLoading}) => {
        return {
            ...state,
            showLoading: showLoading
        };
    }),
    on(generalActions.showLoading, (state, {showLoading}) => {
        return {
            ...state,
            showLoading: showLoading
        };
    })
);

export function generalReducer(state: GeneralState | undefined, action: Action) {
    return _generalReducer(state, action);
}
